/*eslint-disable*/
export const messages = {
  // System notices (truncation / safety refusal)
  "This answer was shortened because it reached the length limit and may be incomplete.": "この回答は文字数の上限に達したため短縮されており、内容が不完全な場合があります。",
  "This request can't be answered due to safety guidelines. Please rephrase or ask about a different topic.": "安全ガイドラインによりこのリクエストにはお答えできません。表現を変えるか、別のトピックについてお尋ねください。",
  "Cancel": "キャンセル",
  "Change theme": "テーマを変更",
  "Clear chat": "チャットをクリア",
  "Clear chat history": "チャット履歴をクリア",
  "Connecting...": "接続中...",
  "Continue": "続ける",
  "Decrease font size": "フォントサイズを小さく",
  "Disclaimer": "免責事項",
  "Enter your message...": "メッセージを入力...",
  "Type your message...": "メッセージを入力...",
  "Error": "エラー",
  "Font size": "フォントサイズ",
  "Increase font size": "フォントサイズを大きく",
  "Language": "言語",
  "MJ Lab": "MJラボ",
  "Reset font size": "フォントサイズをリセット",
  "Respond time: {time}s": "応答時間：{time}秒",
  "Response time:": "応答時間：",
  "Send": "送信",
  "Settings": "設定",
  "Support the project": "プロジェクトを支援",
  "System": "システム",
  "Theme": "テーマ",
  "Thinking...": "考え中...",
  "Toggle theme": "テーマ切替",
  "Welcome to {{name}} by MJ": "MJの{{name}}へようこそ",
  "You asked:": "あなたの質問：",
  
  // Headers
  "Ministry of Commerce Laws Expert": "MoC法律専門家",
  "by MJ": "MJによる",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "こんにちは、私はMJによって作られたAIアシスタントの{{name}}です。",
  "I am expert in Ministry of Commerce laws and regulations for Saudi Arabia.": "私はサウジアラビアの商務省法律と規制について専門知識を持っています。",
  "Ask me a question, and I will gladly answer you.": "質問をしてください、喜んでお答えします。",
  "Do not share confidential data.": "機密データを共有しないでください。",
  "I am powered using": "私は以下を使用して動作しています",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi Ministry of Commerce laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**免責事項：** {{name}}は、サウジアラビアの商務省法律と規制のデータを使用して応答するように設計された実験的なAIアシスタントであり、推測や不正確さを避けています。その行動や回答の正確性については責任を負いません。",
  
  // Frameworks
  "Automatic detection": "自動検出",
  
  // A. Business Formation and Identity
  "MOC_COMPANIES_LAW": "A1. 商務省会社法",
  "MOC_PROFESSIONAL_COMPANIES_LAW": "A2. 商務省専門会社法",
  "MOC_COMMERCIAL_REGISTER_LAW": "A3. 商務省商業登録法",
  "MOC_MINISTRY_OF_COMMERCE_LAW": "A4. 商務省法",
  "MOC_TRADE_NAMES_LAW": "A5. 商務省商号法",
  "MOC_GCC_TRADEMARK_LAW": "A6. 湾岸協力会議商標法",
  
  // B. Financial Instruments, Security, and Insolvency
  "MOC_COMMERCIAL_PAPERS_LAW": "B1. 商務省商業手形法",
  "MOC_COMMERCIAL_PLEDGE_LAW": "B2. 商務省商業質権法",
  "MOC_MOVABLE_PROPERTY_SECURITY_LAW": "B3. 商務省動産担保法",
  "MOC_INSOLVENCY_LAW": "B4. 商務省倒産法",
  
  // C. Commercial Relationships and Trade
  "MOC_COMMERCIAL_AGENCIES_LAW": "C1. 商務省商業代理店法",
  "MOC_FRANCHISE_LAW": "C2. 商務省フランチャイズ法",
  "MOC_ECOMMERCE_LAW": "C3. 商務省電子商取引法",
  "MOC_CHAMBERS_OF_COMMERCE_LAW": "C4. 商務省商工会議所法",
  
  // D. Commercial Records and Information
  "MOC_COMMERCIAL_BOOKS_LAW": "D1. 商務省商業帳簿法",
  "MOC_COMMERCIAL_DATA_LAW": "D2. 商務省商業データ法",
  "MOC_PUBLIC_WAREHOUSING_LAW": "D3. 商務省公共倉庫法",
  
  // E. Standards, Quality, and Regulated Products
  "MOC_STANDARDS_METROLOGY_LAW": "E1. 商務省標準計量法",
  "MOC_CALIBRATION_MEASUREMENT_LAW": "E2. 商務省校正測定法",
  "MOC_PRIVATE_LABORATORIES_LAW": "E3. 商務省民間研究所法",
  "MOC_PRECIOUS_METALS_GEMSTONES_LAW": "E4. 商務省貴金属宝石法",
  "MOC_CHEMICALS_IMPORT_MANAGEMENT_LAW": "E5. 商務省化学物質輸入管理法",
  
  // F. Professional Regulation and Oversight
  "MOC_ACCOUNTING_AUDITING_LAW": "F1. 商務省会計監査法",
  "MOC_VALUERS_LAW": "F2. 商務省評価士法",
  "MOC_ENGINEERS_LAW": "F3. 商務省技術者法",
  
  // G. Compliance and Dispute Resolution
  "MOC_ANTI_CONCEALMENT_LAW": "G1. 商務省偽装防止法",
  "MOC_ANTI_MONEY_LAUNDERING_LAW": "G2. 商務省マネーロンダリング防止法",
  "MOC_ARBITRATION_LAW": "G3. 商務省仲裁法",
  "MOC_COMBATING_COMMERCIAL_ADULTERATION_LAW": "G4. 商務省商業不正防止法",
  "MOC_GCC_COMBATING_DUMPING_LAW": "G5. 湾岸協力会議ダンピング防止法",
  
  // Models
  "Claude by Anthropic": "AnthropicによるClaude",
  "DeepSeek by Groq": "GroqによるDeepSeek",
  "MJ Lab Mode": "MJラボモード",
  
  // Character count
  "{{remainingChars}} character left": "残り{{remainingChars}}文字",
  "{{remainingChars}} characters left": "残り{{remainingChars}}文字",
  
  // Error messages
  "An error occurred": "エラーが発生しました",
  "Failed to change language": "言語の変更に失敗しました",
  "Please try again": "もう一度お試しください",
  "Connection lost": "接続が切断されました",
  "Reconnecting...": "再接続中...",
  "Nothing to clear": "クリアするものがありません",
  "All messages cleared": "すべてのメッセージがクリアされました",
  "All data cleared": "すべてのデータがクリアされました",
  "Storage limit reached": "ストレージ制限に達しました",
  "Some older messages were removed to save space.": "スペースを確保するため、一部の古いメッセージが削除されました。",
  
  // Additional keys
  "Font Size": "フォントサイズ",
  "Language changed to {locale}": "言語が{locale}に変更されました",
  "Select language": "言語を選択",
  "Support": "サポート",
  
  // Brand names (do not translate)
  "Mila": "Mila",
  
  // Message actions
  "Message copied to clipboard": "メッセージをクリップボードにコピーしました",
  "Read": "読む",
  "Summarize": "要約",
  
  // Ice Breakers Dialog
  "Message Suggestions": "メッセージの提案",
  "Select a question to quickly start a conversation about Saudi Ministry of Commerce laws.": "サウジアラビア商務省の法律についての会話をすぐに始めるには質問を選択してください。",
  "What are the main requirements under the Companies Law for establishing a limited liability company in Saudi Arabia?": "サウジアラビアで有限責任会社を設立するための会社法に基づく主な要件は何ですか？",
  "How does the Commercial Agencies Law regulate relationships between foreign companies and Saudi agents?": "商業代理店法はどのように外国企業とサウジアラビアの代理店との関係を規制していますか？",
  "What protections does the Saudi E-commerce Law provide for online consumers and businesses?": "サウジアラビアの電子商取引法はオンライン消費者と企業にどのような保護を提供していますか？",
  
  // Audio Player Dialog
  "AI Summary": "AI要約",
  "Listen to the summarized response using our AI Service.": "AIサービスを使用して要約された回答を聞きます。",
  "Generating summary...": "要約を生成中...",
  "Preparing audio...": "音声を準備中...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "テキストの処理に失敗しました。もう一度お試しください。",
  "Failed to auto-play audio. Click play to try again.": "音声の自動再生に失敗しました。再生をクリックして再試行してください。",
  "Failed to load audio. Please try again.": "音声の読み込みに失敗しました。もう一度お試しください。",
  "Audio playback was aborted.": "音声再生が中断されました。",
  "Network error occurred while loading audio.": "音声の読み込み中にネットワークエラーが発生しました。",
  "Audio decoding failed.": "音声のデコードに失敗しました。",
  "Audio format not supported.": "音声フォーマットがサポートされていません。",
  "Failed to setup audio playback": "音声再生の設定に失敗しました",
  "Failed to generate speech": "音声生成に失敗しました",
  "Failed to generate audio. Please try again.": "音声の生成に失敗しました。もう一度お試しください。",
  "Failed to play audio. Please try again.": "音声の再生に失敗しました。もう一度お試しください。",
  
  // Update Notifications
  "update.updateAvailable": "アップデートが利用可能",
  "update.newVersionAvailable": "新しいバージョン {{version}} が利用可能",
  "update.refreshToApply": "最新の機能と改善を適用するには更新してください",
  "update.later": "後で",
  "update.updateNow": "今すぐ更新"
};